import { render } from "./HelpFormShareFeedback.vue?vue&type=template&id=7d70dc9e&scoped=true"
import script from "./HelpFormShareFeedback.vue?vue&type=script&lang=js"
export * from "./HelpFormShareFeedback.vue?vue&type=script&lang=js"

import "./HelpFormShareFeedback.vue?vue&type=style&index=0&id=7d70dc9e&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d70dc9e"]])

export default __exports__